import styled from 'styled-components'

export const Card = styled.div`
  width: 100%;
  margin-top: 20px;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 2px 0px, rgba(0, 0, 0, 0.06) 2px 8px 20px 0px;
  border-radius: 10px;

  & > p {
    margin-top: 8px;
  }
`
